/* eslint no-undef: 0 */ // --> OFF
export async function fetcher<JSON = any>(
  input: RequestInfo,
  init?: RequestInit,
): Promise<JSON> {
  const res = await fetch(input, init);
  return await res.json();
}
